module.exports = __webpack_public_path__ + "vrplayerstatic/media/floor.5ca1ddda.svg";